import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import fetchDux from '../../../state/fetch-dux';
import LeftNav from './LeftNav';
import EditPaymentForm from './EditProfile/EditPaymentForm';
import MetaTags from 'react-meta-tags';
import MetaLoader from '../../ui/MetaLoader';

class EditPayment extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);

    this.props.getLookups();
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account-add-address',
      'page-template-page-templatesshop-template-my-account-add-address-php',
      'page',
      'page-id-257',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
    this.props.clearPutCard();
  }
  componentWillUnmount() {
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-template-my-account-add-address',
      'page-template-page-templatesshop-template-my-account-add-address-php',
      'page',
      'page-id-257',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }

  render() {
    const {
      putCard,
      putCardError,
      user,
      lookups,
      inProgress,
      history,
      match: { params },
      clearPutCard
    } = this.props;

    const { id } = params || {};

    const activePayment = parseInt(id);

    const {
      userId,
      AddressBook,
      CreditCards,
      IsActiveClubMember
    } = user || {};

    const scrollToTop = () => window.scrollTo(0, 0);

    const handlePutCard = values =>
      putCard({ payload: { ...values, IsActiveClubMember }, id: userId }, 'edit-payment-form', null, () =>
        history.push('/account/edit-profile/payment'));

    const getActivePayment = editingPaymentId => {
      const {
        LastFour,
        ExpirationMonth,
        ExpirationYear,
        AddressBookId,
        CardId,
        IsDefault
      } = (CreditCards || []).find(x => x.CardId === editingPaymentId) || {};

      const {
        FirstName: name_first,
        LastName: name_last
      } = (AddressBook || []).find(x => x.AddressBookID === AddressBookId) || {
      };

      return {
        name_first,
        name_last,
        LastFour,
        ExpirationMonth,
        ExpirationYear,
        AddressBookId,
        cardId: CardId,
        IsDefault
      };
    };

    const paymentFormData = getActivePayment(activePayment);
    const navBackToPayment = () => {
      history.push('/account/edit-profile/payment');
      clearPutCard();
    }
    return (
      <div id="content" className="site-content">
        <MetaLoader title="Manage Payments | Account | Twomey" />
        <MetaTags>
          <title>Manage Payments | Account | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta
            property="og:title"
            content="Manage Payments | Account | Twomey"
          />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content="https://twomey.com/account/edit-profile/payment"
          />
        </MetaTags>
        <div id="primary" className="content-area">

          <main id="main" className="site-main account-page nohero">
            <div className="container">
              <div className="row">
                <LeftNav />
                {!inProgress &&
                  <EditPaymentForm
                    onSubmit={handlePutCard}
                    errorSubmit={putCardError}
                    initialValues={paymentFormData}
                    AddressBook={AddressBook}
                    editType={'Edit'}
                    toggle={navBackToPayment}
                    lookups={lookups}
                  />}
              </div>
            </div>
          </main>

        </div>
        <div className="container text-right">
          <a href="#top" className="back-to-top" onClick={scrollToTop}>
            Back to top
          </a>
        </div>
      </div>
    );
  }
}

const mapState = state => {
  const {
    error: putCardError
  } = state.putCard.toJS();

  const {
    result: user,
    inProgress: userInProgress
  } = state.postLogin.toJS();

  const {
    // error,
    inProgress: lookupsInProgress,
    result: lookups
  } = state.getLookups.toJS();

  return {
    lookups,
    putCardError,
    user,
    inProgress: lookupsInProgress || userInProgress
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      putCard: fetchDux.putCard.createAction,
      clearPutCard: fetchDux.putCard.clearAction,
      getLookups: fetchDux.getLookups.createAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(EditPayment);
